<template>
    <div>
        <home-header-component></home-header-component>
        <header-section></header-section>
        <landing-video></landing-video>
        <brands-components :statistics="landing_data"></brands-components>
        <how-it-works></how-it-works>
        <statistics-component :statistics="landing_data"></statistics-component>
        <ebooks-products></ebooks-products>
        <ready-to-join-creditfixrr></ready-to-join-creditfixrr>
        <plan-component></plan-component>
        <testimonial-component></testimonial-component>
        <!-- <news-letter-component></news-letter-component> -->
        <footer-component></footer-component>
    </div>
</template>
<script>
import HomeHeaderComponent from './Home/HomeHeaderComponent.vue'
import HeaderSection from './Home/HeaderSection.vue'
import LandingVideo from './Home/LandingVideo.vue'
import BrandsComponents from './Home/BrandsComponents.vue'
import HowItWorks from './Home/HowItWorks.vue'
import StatisticsComponent from './Home/StatisticsComponent.vue'
import ReadyToJoinCreditfixrr from './Home/ReadyToJoinCreditfixrr.vue'
import PlanComponent from './Home/PlanComponent.vue'
import TestimonialComponent from './Home/TestimonialComponent.vue'
import NewsLetterComponent from './Home/NewsLetterComponent.vue'
import EbooksProducts from './Home/Landing/EbooksProducts.vue'
import FooterComponent from './Home/FooterComponent.vue'
import {ref} from 'vue'

export default{
    components:{
        HomeHeaderComponent,
        HeaderSection,
        LandingVideo,
        BrandsComponents,
        HowItWorks,
        StatisticsComponent,
        ReadyToJoinCreditfixrr,
        PlanComponent,
        TestimonialComponent,
        NewsLetterComponent,
        EbooksProducts,
        FooterComponent
    },
    setup(){
        return{
            landing_data: ref({})
        }
    },
    mounted(){
        let $this = this;
        const route = this.$router.resolve(
            {
                name:"landing-page"
            }
        );
        axios.post(route.href).then(({data})=>{
            if(data.error ==  false){
                $this.landing_data = data.data;
            }
        });
}
}
</script>
